// extracted by mini-css-extract-plugin
module.exports = {"error":"_5DWfKad2","error__title":"_5D2vA6u2","error__details":"_5D1c1YYR","error__subtitle":"_5D1sOz7x","error__component-stack":"_5DRV-XHc"};